import {
	AudioWaveform,
	BarChart3,
	BookOpen,
	Bot,
	Building,
	Calendar,
	CheckSquare,
	Command,
	DollarSign,
	Droplets,
	FileText,
	Flame,
	FolderOpen,
	Frame,
	GalleryVerticalEnd,
	HelpCircle,
	Home,
	type LucideIcon,
	PieChart,
	Send,
	Settings2,
	SquareTerminal,
	Users,
	Wrench,
	Zap,
} from "lucide-react";

// Icon mapping from string names to actual Lucide React components
export const iconMap: Record<string, LucideIcon> = {
	AudioWaveform,
	BookOpen,
	Bot,
	Command,
	Frame,
	GalleryVerticalEnd,
	PieChart,
	Settings2,
	SquareTerminal,
	Home,
	FolderOpen,
	Users,
	CheckSquare,
	FileText,
	Send,
	Calendar,
	DollarSign,
	BarChart3,
	HelpCircle,
	Wrench,
	Zap,
	Droplets,
	Flame,
	Building,
};

// Helper function to get icon component from string name
export const getIconComponent = (iconName: string): LucideIcon | undefined => {
	return iconMap[iconName];
};

// Helper function to get icon component with fallback
export const getIconComponentWithFallback = (
	iconName: string,
	fallback: LucideIcon = SquareTerminal,
): LucideIcon => {
	return iconMap[iconName] || fallback;
};
